const Footer = () => {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-[#0d1b2a] text-white">
      <div className="container mx-auto px-6 lg:px-20 py-16">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          <div className="lg:col-span-1">
            <img
              src="https://static.readdy.ai/image/df7ad06493c3871277717cdaf248fafe/64c91c6d30c4ecd64eefd4512c25345c.png"
              alt="RBF Express"
              className="h-16 w-auto mb-4"
            />
            <p className="text-white/70 text-sm leading-relaxed max-w-xs mb-6">
              Desde 2007 oferecendo soluções de transporte empresarial com rapidez, eficiência e segurança no Vale do Paraíba e Sudeste.
            </p>
            <div className="flex space-x-3">
              <a
                href="https://www.facebook.com/RBFexpressMotoboy"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-full border border-white/30 flex items-center justify-center hover:bg-[#ff6f00] hover:border-[#ff6f00] transition-all cursor-pointer"
              >
                <i className="ri-facebook-fill text-lg"></i>
              </a>
              <a
                href="https://www.instagram.com/rbfexpress"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-full border border-white/30 flex items-center justify-center hover:bg-[#ff6f00] hover:border-[#ff6f00] transition-all cursor-pointer"
              >
                <i className="ri-instagram-line text-lg"></i>
              </a>
              <a
                href="mailto:rbfexpress@hotmail.com"
                className="w-10 h-10 rounded-full border border-white/30 flex items-center justify-center hover:bg-[#ff6f00] hover:border-[#ff6f00] transition-all cursor-pointer"
              >
                <i className="ri-mail-line text-lg"></i>
              </a>
            </div>
          </div>

          <div>
            <h3 className="text-white font-bold text-xs uppercase tracking-wider mb-4">Serviços</h3>
            <ul className="space-y-3">
              <li>
                <button
                  onClick={() => scrollToSection('servicos')}
                  className="text-white/70 hover:text-[#ff6f00] transition-colors text-sm cursor-pointer"
                >
                  Coletas Empresariais
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('servicos')}
                  className="text-white/70 hover:text-[#ff6f00] transition-colors text-sm cursor-pointer"
                >
                  Transporte de Peças
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('servicos')}
                  className="text-white/70 hover:text-[#ff6f00] transition-colors text-sm cursor-pointer"
                >
                  Malotes Corporativos
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('servicos')}
                  className="text-white/70 hover:text-[#ff6f00] transition-colors text-sm cursor-pointer"
                >
                  Entregas Rápidas
                </button>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-white font-bold text-xs uppercase tracking-wider mb-4">Empresa</h3>
            <ul className="space-y-3">
              <li>
                <button
                  onClick={() => scrollToSection('solucoes')}
                  className="text-white/70 hover:text-[#ff6f00] transition-colors text-sm cursor-pointer"
                >
                  Sobre Nós
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('regioes')}
                  className="text-white/70 hover:text-[#ff6f00] transition-colors text-sm cursor-pointer"
                >
                  Regiões Atendidas
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('frota')}
                  className="text-white/70 hover:text-[#ff6f00] transition-colors text-sm cursor-pointer"
                >
                  Nossa Frota
                </button>
              </li>
              <li>
                <a
                  href="mailto:rbfexpress@hotmail.com"
                  className="text-white/70 hover:text-[#ff6f00] transition-colors text-sm cursor-pointer"
                >
                  Trabalhe Conosco
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-white font-bold text-xs uppercase tracking-wider mb-4">Contato</h3>
            <ul className="space-y-3 text-sm text-white/70">
              <li className="flex items-start">
                <i className="ri-phone-line mr-2 mt-1 text-[#ff6f00]"></i>
                <a href="tel:+551239118942" className="hover:text-[#ff6f00] transition-colors cursor-pointer">
                  (12) 3911-8942
                </a>
              </li>
              <li className="flex items-start">
                <i className="ri-whatsapp-line mr-2 mt-1 text-[#ff6f00]"></i>
                <a href="https://wa.me/5512991064271?text=Ol%C3%A1!%20Gostaria%20de%20um%20or%C3%A7amento%20para%20transporte%20de%20pe%C3%A7as%2Finsumos%2Fdocumentos%20para%20minha%20empresa." target="_blank" rel="noopener noreferrer" className="hover:text-[#ff6f00] transition-colors cursor-pointer">
                  (12) 99106-4271
                </a>
              </li>
              <li className="flex items-start">
                <i className="ri-mail-line mr-2 mt-1 text-[#ff6f00]"></i>
                <a href="mailto:rbfexpress@hotmail.com" className="hover:text-[#ff6f00] transition-colors cursor-pointer">
                  rbfexpress@hotmail.com
                </a>
              </li>
              <li className="flex items-start">
                <i className="ri-map-pin-line mr-2 mt-1 text-[#ff6f00]"></i>
                <span>Rua Espírito Santo, 46<br />Vila São Pedro<br />São José dos Campos - SP</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/10 pt-8 flex flex-col md:flex-row justify-between items-center">
          <p className="text-white/50 text-sm mb-4 md:mb-0">
            © 2026 RBF Express. Todos os direitos reservados.
          </p>
          <div className="flex items-center space-x-4 text-sm">
            <a href="https://readdy.ai/?ref=logo" target="_blank" rel="noopener noreferrer" className="text-white/50 hover:text-[#ff6f00] transition-colors cursor-pointer">
              Powered by Readdy
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
